<template>
  <v-container fluid class="fill-height align-start">
    <Loading v-if="loading" />
    <div v-else class="fill-width deposit-details pa-2">
      <v-row
        class="fill-width flex-column ma-0"
        align="center"
        justify="center"
        no-gutters
      >
        <v-img
          v-if="depositDetails.logo"
          width="94"
          height="94"
          contain
          :src="depositDetails.logo"
        ></v-img>
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="blue" v-bind="attrs" v-on="on" class="mt-4"
              >mdi-information-outline</v-icon
            >
          </template>
          <span>{{ $t("panel.transactionPage.deposit.details.tooltip") }}</span>
        </v-tooltip>
        <v-card-title
          >{{ $t("panel.transactionPage.deposit.details.title") }}
          {{ depositDetails.cryptoAmount }}</v-card-title
        >
        <v-chip
          label
          :color="
            $transactionStatusColor(depositDetails.transactionStatus).color
          "
          :text-color="
            $transactionStatusColor(depositDetails.transactionStatus).textColor
          "
          class="text-center"
          >{{ depositDetails.transactionStatus }}</v-chip
        >
        <!--        <v-card-actions>-->
        <!--          <v-btn depressed color="primary" class="mt-1">{{-->
        <!--            $t("panel.transactionPage.deposit.details.checkStatus")-->
        <!--          }}</v-btn>-->
        <!--        </v-card-actions>-->
        <v-card class="align-self-start fill-width" elevation="0">
          <ul
            v-for="item in $t(
              'panel.transactionPage.deposit.details.cardTitle'
            )"
            :key="item.value"
            class="px-0 details"
          >
            <v-card class="d-flex align-center justify-start" elevation="0">
              <v-card-text class="width-auto pe-1 text-no-wrap">{{
                item.text
              }}</v-card-text>
              <v-tooltip
                v-if="item.tooltip"
                top
                color="primary"
                class="width-auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="blue" v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
              <v-card-text
                v-if="!item.condition"
                class="width-auto font-medium-16 gray10--text ml-auto text-right details-value"
                ><span v-if="item.value === 'transactionTime'">{{
                  depositDetails[item.value] | $renderDate
                }}</span
                ><span
                  v-else-if="item.value === 'depositDetailResponseDto'"
                  class="d-flex flex-column align-start"
                  ><span
                    v-for="val in depositDetails[item.value]"
                    :key="val.transactionHash"
                    >{{ val.transactionHash }}</span
                  ></span
                ><span v-else>{{
                  depositDetails[item.value]
                }}</span></v-card-text
              >
              <a
                v-else
                :href="depositDetails[item.value]"
                target="_blank"
                class="external-link d-block ml-auto"
              >
                <span class="text-decoration-underline font-semiBold-16">{{
                  item.valueText
                }}</span>
                <v-icon small icon color="primary" class="ms-1"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </v-card>
            <v-divider class="mx-4" />
          </ul>
        </v-card>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { transactionsService } from "@/services";
import renderDate from "@/mixins/renderDate";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import Loading from "@/components/Common/Loading";

export default {
  name: "deposit-details",
  components: { Loading },
  props: ["transactionId"],
  mixins: [renderDate, tableStatusItemColor],
  data() {
    return {
      depositDetails: {},
      loading: false
    };
  },
  created() {
    this.getDepositTrxDetails();
  },
  methods: {
    getDepositTrxDetails() {
      this.loading = true;
      transactionsService
        .getDepositTrxById(this.transactionId)
        .then(response => {
          this.depositDetails = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "DepositDetails";
</style>
